import M$plugin$XYLocator from './facade/js/xylocator';
import M$control$XYLocatorControl from './facade/js/xylocatorcontrol';
import M$impl$control$XYLocatorControl from './impl/ol/js/xylocatorcontrol';

if (!window.M.plugin) window.M.plugin = {};
if (!window.M.control) window.M.control = {};
if (!window.M.impl) window.M.impl = {};
if (!window.M.impl.control) window.M.impl.control = {};
window.M.plugin.XYLocator = M$plugin$XYLocator;
window.M.control.XYLocatorControl = M$control$XYLocatorControl;
window.M.impl.control.XYLocatorControl = M$impl$control$XYLocatorControl;
